import { render, staticRenderFns } from "./smallTitle.vue?vue&type=template&id=5d40e512&scoped=true"
import script from "./smallTitle.vue?vue&type=script&lang=js"
export * from "./smallTitle.vue?vue&type=script&lang=js"
import style0 from "./smallTitle.vue?vue&type=style&index=0&id=5d40e512&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d40e512",
  null
  
)

export default component.exports